import React, { useState, useEffect } from "react";
import { Button, Divider, Grid, MenuItem, Typography } from "@mui/material";
import CustomTextField from "src/components/forms/theme-elements/CustomTextField";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import ParentCard from "src/components/shared/ParentCard";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate, useParams } from "react-router";
import SubscriptionService from "src/service/subscription";
import swal from "sweetalert";
import CustomSelect from "src/components/forms/theme-elements/CustomSelect";
import { IconArrowBack } from "@tabler/icons";
const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: " Update Plan and Subscription ",
  },
];

const validationSchema = yup.object({
  plan_type: yup.number("Select User Type").required("User Type is Required"),

  plan_name: yup
    .string("paln Name")
    .min(2, "paln Name should be of minimum 2 characters in length")
    .max(30, "paln Name should be of maximum 30 characters in length")
    .required("paln Name is required"),

  validity: yup
    .string("Enter User Name")
    .matches(/^[0-9]+$/, "plan validity should only contain digits")
    .min(2, "User Name should be of minimum 2 characters in length")
    .max(30, "User Name should be of maximum 30 characters in length")
    .required("User Name is required"),

  charge: yup
    .string("plan charge")
    .matches(/^[0-9.]+$/, "plan charge should only contain digits")
    .min(2, "paln charge should be of minimum 2 characters in length")
    .max(30, "paln charge should be of minimum 30 characters in length")
    .required("paln charge is required"),
});

const UpdatePlanSubscription = () => {
  const sessionData = JSON.parse(localStorage.getItem("user"));
  const param = useParams();

  const navigate = useNavigate();

  const [initialValues, setInitialValues] = useState({
    id: param.id,
    plan_name: "",
    plan_type: "",
    validity: "",
    charge: "",
    d_by: sessionData.data.id,
  });

  useEffect(() => {
    const fetchplanSubsData = async () => {
      try {
        const res = await SubscriptionService.getSubscription({
          id: param.id,
        });

        // Update the initialValues once data is fetched
        setInitialValues({
          id: param.id,
          plan_name: res.data[0].plan_name,
          plan_type: res.data[0].plan_type,
          validity: res.data[0].validity,
          charge: res.data[0].charge,
          d_by: sessionData.data.id,
        });
      } catch (error) {
        console.log(error);
      }
    };
    fetchplanSubsData();
  }, [param.id, sessionData.data.id, sessionData.data.user_type]);

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } =
    useFormik({
      enableReinitialize: true,
      initialValues: initialValues,
      validationSchema: validationSchema,
      onSubmit: async (values) => {
        // alert(JSON.stringify(values, null, 2));

        try {
          const res = await SubscriptionService.updateSubscription(values);
          swal("success", res.message, "success");
          setTimeout(() => {
            navigate("/planAndSubscription");
          }, 1000);
        } catch (error) {
          swal("error", error, "error");
        }
      },
    });

  // =============================

  return (
    <div>
      <Breadcrumb title=" Update Plan and Subscription " items={BCrumb} />
      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Update Plan and Subscription
            </Typography>
          </Grid>

          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate("/planAndSubscription");
              }}
            >
              <IconArrowBack width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />

        <form onSubmit={handleSubmit}>
          <Grid container spacing={3} style={{ marginTop: "5px" }}>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <CustomFormLabel htmlFor="plan_name">
                Plan Name <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="plan_name"
                name="plan_name"
                type="text"
                value={values.plan_name}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.plan_name && Boolean(errors.plan_name)}
                helperText={touched.plan_name && errors.plan_name}
                variant="outlined"
                placeholder="Enter plan name"
                fullWidth
              />
            </Grid>
            {/*   ====  user type  -===  */}
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <CustomFormLabel htmlFor="plan_type">
                Plan Type <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomSelect
                id="plan_type"
                name="plan_type"
                value={values.plan_type}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.plan_type && Boolean(errors.plan_type)}
                fullWidth
                variant="outlined"
              >
                <MenuItem value="1">One Time</MenuItem>
                <MenuItem value="2">Yearly</MenuItem>
              </CustomSelect>
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <CustomFormLabel htmlFor="validity">
                Plan Validity <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="validity"
                name="validity"
                type="text"
                value={values.validity}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.validity && Boolean(errors.validity)}
                helperText={touched.validity && errors.validity}
                variant="outlined"
                placeholder="Enter Plan validity"
                fullWidth
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <CustomFormLabel htmlFor="charge">
                Plan Charge <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="charge"
                name="charge"
                type="text"
                value={values.charge}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.charge && Boolean(errors.charge)}
                helperText={touched.charge && errors.charge}
                variant="outlined"
                placeholder="Enter Plan charge"
                fullWidth
              />
            </Grid>
          </Grid>
          <Grid
            item
            lg={6}
            md={12}
            sm={12}
            xs={12}
            style={{ marginTop: "20px" }}
          >
            <Button color="primary" variant="contained" type="submit">
              Submit
            </Button>
          </Grid>
        </form>
      </ParentCard>
    </div>
  );
};

export default UpdatePlanSubscription;
